import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]

  submit(e) {
    e.preventDefault()

    if (!this.element.checkValidity()) {
      this.element.reportValidity()
      return
    }

    // We use a full page reload to avoid the complexity of Recaptcha initialization
    // It requires disabling the button manually on submit
    this.submitButtonTarget.disabled = true

    grecaptcha.execute()
  }
}
